<template>
    <tr>
        <td scope="row">
            <img width="100"
            src="https://is3-ssl.mzstatic.com/image/thumb/Purple113/v4/b8/65/91/b86591d3-42d9-eb9f-b2e1-d237da57974e/SteamMobileAppIcon-0-0-1x_U007emarketing-0-0-0-7-85-220.png/1200x630wa.png"
            alt="image">
        </td>
        <td style="width: 20rem;">Steam</td>
        <td>Rp 150.000</td>
        <td>2</td>
    </tr>
</template>

<script>
export default {
  name: 'TransactionDatas'
}
</script>

<style>

</style>
